import React, { useEffect, useState } from "react";
import transactionServices from "../../services/transactionServices";
import { useSelector } from "react-redux";
import { convertToIndianFormat } from "../../utils/functions";
import moment from "moment";
import { AmountPaidCommited, DetailButton, TableRow, TableRowImg, TableRowMultilineInfo, TxnRefNumber } from "../../components/miniComponents";
import CustomTable from "../../components/customTable";
import { AllTranSaction, EmptyTableState, FamilyMemberTransaction, HUFTransaction, PersonalTransaction } from "../../components/tables";
import DataGridTable from "../../components/DataGridTabel";
import { Box, Button, Divider, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import Tabs from "../../components/tabs/tabs";
import ModalComponent from "../../components/modals/modalComponent";
import AllTransactionByListing from "../../components/transactionTable/AllTransactionByListingNdUser";
import TransactionsCardList from "../../components/transactionCards/TransactionsCardList";

const CanceledTransactions = ({ title }) => {
    const user = useSelector(state => state.user.data);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [data, setData] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [paymentAccount, setPaymentAccount] = useState(false)
    const [openTransactionModal, setOpenTransationModal] = useState(false);
    const [transactionProp, setTransactionProp] = useState({});
    const [status, setStatus] = useState();
    const [noOfFrax, setNoOfFrax] = useState();
    const [propertyId, setPropertyId] = useState();
    const [tokenName,setTokenName]=useState('');
    const [expandedRejectReasons, setExpandedRejectReasons] = useState({});
    const handleTabClick = (index) => {
        setActiveTab(index);
    }
    useEffect(() => {
        getMyInvestments();
    }, [])

    const getMyInvestments = async () => {
        let reqData = {
            investorId: user._id,
            statusArray: ['REJECTED', 'EXPIRED']
        };

        const res = await transactionServices.getTransactionByLisitngAndUser(reqData);

        if (res && res.success && res.data?.length > 0) {
            let tempData = [];
            for (let e of res.data) {

                let temp = {
                    propertyInfo: [
                        e?.listing?.title || e.project.projectName,
                        res.url + (e?.listingImages[0]?.docUrl || ""),
                        e.project.projectName,
                        e.listing.propertyCode,
                    ],
                    imgUrl: res.url + (e?.listingImages[0]?.docUrl || ""),
                    assetName: e?.listing?.title,
                    payments: e?.payments?.map(payment => ({
                        ...payment,
                        rpf: e?.rpf,
                        amount: e?.amount,
                        investorName: e.investorName,
                    })) || [],
                    propertyId: e.listingId,
                    frax: e.noOfFracs,
                    noOfFracs: e.noOfFracs,
                    investAmm: `₹ ${e.amount}` || 0,
                    pendingAmount: `₹ ${e.pendingAmt}` || 0,
                    date: moment(e.created_at).format("DD/MM/YYYY") || "12/12/2000",
                    uDate: moment(e.created_at).format("DD/MM/YYYY") || "12/12/2000",
                    percentInvested: `${e.propertyPercent} %`,
                    status: e.status,
                    listingId: e.listingId,
                    projectId: e.projectId,
                    _id: e._id,
                    transactionId: e.transactionId,
                    saleDeed: res.url + (e?.listing?.registrationCertificate[0]?.docUrl || ""),
                    rejectReason: e.rejectReason || 'No reason available',
                    isHuf: e.isHuf,
                    familyMemberId: e.familyMemberId,
                    username: e.familyMember?.username,
                    relation: e.familyMemberInvestor?.relation,
                    entityType: e.entityType,
                    tokenName:e?.assetclass?.tokenName ? e?.assetclass?.tokenName.toUpperCase():"FRAX"
                };
                tempData.push(temp);
            }

            setData(tempData);
        } else {

        }
    };
    const huftransaction = data.filter(transaction => transaction.isHuf === true);

    const familymemberTransaction = data.filter(data =>
        'familyMemberId' in data && data.familyMemberId !== null && data.familyMemberId !== undefined
    );
    const personalTransaction = data.filter(transaction => transaction.isHuf === false && transaction.familyMemberId == null && transaction.familyMemberId == undefined);

    const toCardRow = (row) => ({
        ...row,
        propertyName: row.assetName,
        created_at: row.date,
        lastPaymentDate: row.uDate,
        noOfFracs: row.frax ?? row.noOfFracs,
    });

    const renderAmount = (row) => (
        <Typography variant="body3">{row.investAmm || "-"}</Typography>
    );

    const renderRejectReason = (row) => {
        const reason = row.rejectReason || "-";
        const isExpanded = Boolean(expandedRejectReasons[row._id]);
        const showToggle = typeof reason === "string" && reason.length > 90;

        return (
            <Stack spacing={0.5}>
                <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="flex-start">
                    <Typography variant="label">Reject Reason</Typography>
                    <Typography
                        variant="body3"
                        sx={{
                            textAlign: "right",
                            wordBreak: "break-word",
                            maxWidth: "70%",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            WebkitLineClamp: isExpanded ? "unset" : 2,
                        }}
                    >
                        {reason}
                    </Typography>
                </Stack>

                {showToggle && (
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            size="small"
                            variant="text"
                            sx={{ p: 0, minWidth: "auto", textTransform: "none" }}
                            onClick={() =>
                                setExpandedRejectReasons((prev) => ({
                                    ...prev,
                                    [row._id]: !prev[row._id],
                                }))
                            }
                        >
                            {isExpanded ? "View less" : "View more"}
                        </Button>
                    </Box>
                )}
            </Stack>
        );
    };

    const handleViewPayments = (row) => {
        setTokenName(row.tokenName)
        setTransactionProp(row.payments)
        setStatus(row.status)
        setNoOfFrax(row.noOfFracs ?? row.frax)
        setPropertyId(row.listingId)
        setOpenTransationModal((prev) => !prev)
    };

    const table = [
        {
            field: 'imgUrl',
            headerName: 'Asset Image',
            flex: 1,
            renderCell: (params) => {
                return <><div style={{ display: "flex", justifyContent: "center", width: "100%", height: "100%", padding: "2px" }}><img src={params.row.imgUrl} alt="Property" style={{ width: '100px', height: 'auto', borderRadius: "4px" }} /></div>
                </>;
            }
        },
        paymentAccount ? {
            field: "isHuf", headerName: "Payment Account", flex: 1.5, alignItems: "center", textAlign: "center",
            renderCell: (params) => {

                if (params.row.isHuf) {
                    return <Typography variant="body3">HUF</Typography>
                } else if (params.row.familyMemberId) {
                    return <Typography variant="body3">{params.row?.username ? `${params.row?.username}(${params.row?.relation})` : "Family"}</Typography>
                }
                else {
                    return <Typography variant="body3">Personal</Typography>
                }
            }
        } : null,
        { field: 'assetName', headerName: 'Asset Name', flex: 1 },
        { field: 'investAmm', headerName: 'Amount Commited', flex: 1 },
        { field: 'frax', headerName: 'No of Token', flex: 1 },
        {
            field: "isHuf", headerName: "Payment Account", flex: 1.5, alignItems: "center", textAlign: "center",
            renderCell: (params) => {
                if (params.row.entityType === "HUF") {
                    return <Typography variant="body3">HUF</Typography>
                } else if (params.row.entityType === "TRUST") {
                    return <Typography variant="body3">TRUST</Typography>
                } else if (params.row.entityType === "FAMILYMEMBER") {
                    return <Typography variant="body3">{params.row?.username ? `${params.row?.username}(${params.row?.relation})` : "Family"}</Typography>
                }
                else {
                    return <Typography variant="body3">Personal</Typography>
                }
            }
        },
        { field: 'percentInvested', headerName: '% Ownership', flex: 1 },
        { field: 'rejectReason', headerName: 'Reject Reason', flex: 2 },
        {
            field: 'proop',
            headerName: '',
            flex: 1.5,
            renderCell: (params) => {
                const handleClick = () => {
                    setTokenName(params.row.tokenName)
                    setTransactionProp(params.row.payments)
                    setStatus(params.row.status)
                    setNoOfFrax(params.row.noOfFracs)
                    setPropertyId(params.row.listingId)
                    setOpenTransationModal((prev) => !prev)
                };

                return (
                    <Button
                        onClick={handleClick}
                        style={{ padding: "10px", fontSize: "12px" }}
                        variant="contained"
                    >
                        {'View Payments'}
                    </Button>
                );
            },
        },
    ].filter(Boolean)

    const tabs = [
        {
            name: title || "All Transactions",
            tab: isMobile ? (
                <TransactionsCardList
                    rows={data.map(toCardRow)}
                    showPaymentAccount={true}
                    renderAmount={renderAmount}
                    renderExtra={renderRejectReason}
                    onViewPayments={handleViewPayments}
                    emptyState={<EmptyTableState showAction={true} title={"No Properties"} subtitle={"You've not made any investments yet."} />}
                />
            ) : (
                <AllTranSaction data={data} table={table} setPaymentAccount={setPaymentAccount} />
            )
        },
        personalTransaction.length > 0 ? {
            name: title || "Personal",
            tab: isMobile ? (
                <TransactionsCardList
                    rows={personalTransaction.map(toCardRow)}
                    showPaymentAccount={false}
                    renderAmount={renderAmount}
                    renderExtra={renderRejectReason}
                    onViewPayments={handleViewPayments}
                    emptyState={<EmptyTableState showAction={true} title={"No Properties"} subtitle={"You've not made any investments yet."} />}
                />
            ) : (
                <PersonalTransaction data={personalTransaction} table={table} setPaymentAccount={setPaymentAccount} />
            )
        } : null,
        familymemberTransaction.length > 0 ? {
            name: title || "Family Member",
            tab: isMobile ? (
                <TransactionsCardList
                    rows={familymemberTransaction.map(toCardRow)}
                    showPaymentAccount={true}
                    renderAmount={renderAmount}
                    renderExtra={renderRejectReason}
                    onViewPayments={handleViewPayments}
                    emptyState={<EmptyTableState showAction={true} title={"No Properties"} subtitle={"You've not made any investments yet."} />}
                />
            ) : (
                <FamilyMemberTransaction data={familymemberTransaction} table={table} setPaymentAccount={setPaymentAccount} />
            )
        } : null,
        huftransaction.length > 0 ? {
            name: title || "HUF",
            tab: isMobile ? (
                <TransactionsCardList
                    rows={huftransaction.map(toCardRow)}
                    showPaymentAccount={false}
                    renderAmount={renderAmount}
                    renderExtra={renderRejectReason}
                    onViewPayments={handleViewPayments}
                    emptyState={<EmptyTableState showAction={true} title={"No Properties"} subtitle={"You've not made any investments yet."} />}
                />
            ) : (
                <HUFTransaction data={huftransaction} table={table} setPaymentAccount={setPaymentAccount} />
            )
        } : null
    ].filter(Boolean);
    // const tableCells = [<TableRowImg />, <TableRowMultilineInfo />, <TableRow />, <TableRow />, <TableRow />, <TableRow />];
    if (data.length === 0)
        return (<EmptyTableState showAction={true} title={"No Properties"} subtitle={"You've not made any investments yet."} />)
    // eslint-disable-next-line
    return (
        <>
            {isMobile ? (
                <Box>
                    <Box sx={{ mt: { md: 2, xs: 2 } }}>
                        <Stack>
                            <Box mb={3}>
                                <Box sx={{ mx: { md: "46px", xs: 0 }, px: { xs: 2, md: 0 } }}>
                                    {data && <Tabs activeTab={activeTab} tabs={tabs} onClick={handleTabClick} />}
                                </Box>
                                <Divider sx={{ width: "calc(100% + 80px)" }} />
                            </Box>
                            <Box>{tabs[activeTab]?.tab}</Box>
                        </Stack>
                    </Box>
                </Box>
            ) : (
                <>
                    {(huftransaction.length == 0 && familymemberTransaction.length == 0) && (
                        <DataGridTable initialColumns={table} initialRows={data} />
                    )}
                    {(huftransaction.length > 0 || familymemberTransaction.length > 0) && <Box>
                <Box
                    sx={{ mt: { md: 2, xs: 2 } }}
                >
                    <Stack>

                        <Box mb={3}  >
                            <Box sx={{ mx: "46px" }} >
                                {data &&
                                    <Tabs activeTab={activeTab} tabs={tabs} onClick={handleTabClick} />
                                }
                            </Box>
                            <Divider sx={{
                                width: "calc(100% + 80px)",

                            }} />
                        </Box>


                        <Box >
                            {

                                tabs[activeTab]?.tab
                            }
                        </Box>
                    </Stack>
                </Box>

                {/* } */}

            </Box>}
                </>
            )}
            {openTransactionModal && (
                <ModalComponent
                    open={openTransactionModal}
                    handleClose={() => setOpenTransationModal((prev) => !prev)}
                    fullScreen={isMobile}
                    fullWidth={!isMobile}
                    maxWidth={isMobile ? false : "md"}
                    title="All Payments"
                    titleStyle={{ fontWeight: 400, mb: 1, pl: 0, fontSize: isMobile ? "1.05rem !important" : "1.4rem !important" }}
                    children={<AllTransactionByListing tokenName={tokenName}data={transactionProp} status={status} noOfFrax={noOfFrax} propertyId={propertyId} />}
                />
            )}
        </>
    )
};

export default CanceledTransactions;